import { cx, css } from '@linaria/core';
import { flex } from 'styles/utils';
import { tooltipStyles } from 'components/Tooltip/Tooltip.styles';
export const wfOnlyTooltip = cx("omponents__EntityCard__Footer_styled_ts-wfOnlyTooltip-w22f93h", tooltipStyles);
export const wfOnly = cx("omponents__EntityCard__Footer_styled_ts-wfOnly-w1ojz273", flex.init, flex.alignItems.center);

require("./Footer.styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Footer.styled.ts");